<template>
	<div v-if="blok" v-editable="blok">
		<!--
			A styled title sits outside `.rich-text`: templates size
			`.rich-text h2` with plain CSS that would out-rank the utility
			classes. Unstyled, it stays inside and renders exactly as before.
			Outside, a template can give it a default size through
			`.faq-group-title` (in `@layer components`, so a picked size still
			wins); otherwise the template's own h2 styles apply.
		-->
		<h2
			v-if="blok.title && titleClass"
			class="faq-group-title mb-4"
			:class="titleClass"
		>
			{{ blok.title }}
		</h2>
		<div class="rich-text">
			<h2 v-if="blok.title && !titleClass">
				{{ blok.title }}
			</h2>
			<AnimatedDisclosure
				v-for="item in blok.items"
				:key="item._uid"
				:title="item.title"
				:title-class="itemTitleClass"
				:divider-class="dividerClass"
			>
				<StoryblokComponent
					v-for="content in item.content"
					:key="content._uid"
					:blok="content"
				/>
			</AnimatedDisclosure>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { FaqGroup } from "~/types/storyblok/storyblok";
import {
	styleClasses,
	typographyWithWeight
} from "~/layers/base/utils/blokStyleOptions";

interface Props {
	blok: FaqGroup;
}

const { blok } = defineProps<Props>();

const titleClass = computed(() => styleClasses(blok.title_styles));
const itemTitleClass = computed(() =>
	typographyWithWeight(blok.item_title_styles, "font-bold")
);
const dividerClass = computed(
	() => styleClasses(blok.divider_styles) || "border-b"
);
</script>
